import { startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function pipelineStartCoroutineUninterceptedOrReturn(interceptor, context, subject, continuation) {
  var coroutine = pipelineStartCoroutineUninterceptedOrReturn$slambda(interceptor, context, subject);
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
  return startCoroutineUninterceptedOrReturnGeneratorVersion(coroutine, continuation);
}
function pipelineStartCoroutineUninterceptedOrReturn$slambda($interceptor, $context, $subject) {
  return constructCallableReference(function *($completion) {
    yield* $interceptor($context, $subject, $completion);
    return Unit_instance;
  }, 0);
}
//region block: exports
export {
  pipelineStartCoroutineUninterceptedOrReturn as pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2,
};
//endregion

//# sourceMappingURL=Pipeline.web.mjs.map
